const UpDown2 = [
    {id: "0", value: "上升"},    
    {id: "1", value: "下降"}
  ];  
  
  export default UpDown2